import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import AreaChart from "../../../Components/Charts/AreaChart";
import { axInst } from "../../../Components/Login/Service";

const fetchDealerServiceRevenueStreams = async (body) => {
  try {
    const res = await axInst.post(
      "collbax-service/collbax_service_zone_revenue",
      body,
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const fetchDealerServiceRevenueStreamsSecond = async (body) => {
  try {
    const res = await axInst.post(
      "collbax-service/collbax_zone_job_card",
      body,
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export default function DealerServiceRevenueStreams() {
  const { data, submitted } = useSelector((e) => e.filtersServiceCollabax);

  const payload = {
    ...data,
    Dealer_status: "Revenue Streams",
  };

  const {
    data: apiData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["dealerServiceRevenueStreams", payload],
    queryFn: () => fetchDealerServiceRevenueStreams(payload),
    cacheTime: 0,
    staleTime: 0,
  });

  const {
    data: apiData2,
    isFetching: isFetching2,
    isError: isError2,
  } = useQuery({
    queryKey: ["dealerServiceRevenueStreamsSecond", payload],
    queryFn: () => fetchDealerServiceRevenueStreamsSecond(payload),
    cacheTime: 0,
    staleTime: 0,
  });

  if (isFetching || isFetching2)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  if (isError || isError2) return <div>Error loading data</div>;

  const combinedData = { ...(apiData || {}), ...(apiData2 || {}) };

  // 🔥 Transform API response correctly
  const chartsData =
    Object.keys(combinedData).length > 0
      ? Object.entries(combinedData).map(([title, value]) => {
          const keys = Object.keys(value);
          const prevFY = keys.find((key) => key.startsWith("FY"));
          const currFY = keys.find((key) => key.startsWith("YTD_FY"));

          return {
            title,
            monthlyData: value.Month_wise_revenue || {},
            target: value.Target,
            previousYear: {
              label: prevFY,
              value: prevFY ? value[prevFY] : null,
            },
            ytdActual: currFY
              ? { label: currFY, value: value[currFY] }
              : value.YTD_Actual,
          };
        })
      : [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
      {chartsData.map((chart, index) => {
        let endpoint = "collbax-service/collbax_sso_service_revenue";
        let modalPayload = {};

        const titleLower = chart?.title?.toLowerCase() || "";

        if (
          titleLower.includes("total") &&
          titleLower.includes("accident") &&
          titleLower.includes("revenue")
        ) {
          endpoint = "collbax-service/collbax_sso_service_revenue";
          modalPayload = { Percentage_status: "ACCIDENT_PERCENTAGE" };
        } else if (
          titleLower.includes("open") &&
          titleLower.includes("job") &&
          titleLower.includes("card")
        ) {
          endpoint =
            "collbax-service/collbax_service_sso_operational_efficiency";
          modalPayload = { Partner_Type: [], sso_status: "OPEN_JOB_CARD" };
        }

        return (
          <AreaChart
            key={index}
            title={chart.title}
            data={chart.monthlyData}
            target={chart.target}
            previousYear={chart.previousYear}
            ytdActual={chart.ytdActual}
            modalEndpoint={endpoint}
            modalPayload={modalPayload}
          />
        );
      })}
    </div>
  );
}
